"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Profile2.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Profile2 = function Profile2(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 42.96 54.43"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Profile Icon"), _react2.default.createElement("g", {
    className: "profile",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "body",
    d: "M40.86 54.43a2.1 2.1 0 0 1-2.1-2.1 17.28 17.28 0 0 0-34.55 0 2.1 2.1 0 0 1-4.21 0 21.48 21.48 0 0 1 43 0 2.1 2.1 0 0 1-2.14 2.1z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "head",
    d: "M21.48 29A14.51 14.51 0 1 1 36 14.51 14.52 14.52 0 0 1 21.48 29zm0-24.81a10.3 10.3 0 1 0 10.3 10.3 10.31 10.31 0 0 0-10.3-10.28z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = Profile2;